module.exports = __webpack_public_path__ + "templates/loyalty-card.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/loyalty/templates/loyalty-card.html
// module id = FZMx
// module chunks = 1